import { Component, Inject } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GenericBaseComponent } from 'app/shared/components/base/generic-base/generic-base.component';
import { Constants } from 'app/shared/constants/constants';
import { FilterBase } from 'app/shared/filters/filter-base';
import { ModalComponentFactory } from 'app/shared/models/modal-component-factory.model';
import { PageConfiguration } from 'app/shared/models/page-configuration.model';
import { SectionService } from 'app/shared/services/section.service';

@Component({
  selector: 'app-list-base',
  templateUrl: './list-base.component.html',
  styleUrls: ['./list-base.component.scss']
})

export abstract class ListBaseComponent extends GenericBaseComponent {

  collection: any;
  pageConfiguration: PageConfiguration;
  filterBase: FilterBase;

  constructor(protected sectionService: SectionService, @Inject('sectionName') protected sectionName: string,
              protected modalService?: NgbModal, @Inject('modalClassName') protected modalClassName?: string) {
    super(sectionService, sectionName);
  }

  initializeView(orderBy: string, isAscending: boolean, pageSize?: number, initializeCollection: boolean = true): void {
    super.initialize();

    this.pageConfiguration = new PageConfiguration(orderBy, isAscending, pageSize);
    this.filterBase = new FilterBase();

    if (initializeCollection) {
      this.getCollection(Constants.DefaultPageNumber);
    }
  }

  getTableHeaderClass(canSort: boolean, isAscending: boolean, displayClass: string): string {
    if (!canSort) {
      return displayClass;
    }

    if (isAscending) {
      return 'asc ' + displayClass;
    } else {
      return 'desc ' + displayClass;
    }
  }

  openModal(): NgbModalRef {
    return this.openModalInternal(this.modalClassName);
  }

  openCustomModal(className: string, currentObject: object, backdropClass?: string): NgbModalRef {
    const modalReference = this.openModalInternal(className, backdropClass);
    modalReference.componentInstance.currentObject = Object.assign({}, currentObject);

    return modalReference;
  }

  openCustomModalById(className: string, currentObjectId: number): NgbModalRef {
    const modalReference = this.openModalInternal(className);
    modalReference.componentInstance.currentObjectId = currentObjectId;

    return modalReference;
  }

  private openModalInternal(className: string, backdropClass?: string): NgbModalRef {
    const modalReference = this.modalService.open(this.getModalComponentByClassName(className), {
      windowClass: 'add-edit-modal',
      backdropClass
    });
    modalReference.componentInstance.afterSubmitEvent.subscribe(() => {
      modalReference.close();
      this.getCollection(null);
    });

    return modalReference;
  }

  openEditModal(currentObject: object, readonly: boolean = false): NgbModalRef {
    const modalReference = this.openModal();
    modalReference.componentInstance.currentObject = Object.assign({}, currentObject);

    if (readonly != null) {
      modalReference.componentInstance.isReadOnly = readonly;
    }

    return modalReference;
  }

  searchFilter(event: any): void {
    this.filterBase.Name = event.target.value.toLowerCase();
    this.getCollection(Constants.DefaultPageNumber);
  }

  sort(canSort: boolean, column: string): void {
    if (canSort) {
      this.pageConfiguration.OrderBy = column;
      this.pageConfiguration.IsAscending = !this.pageConfiguration.IsAscending;
      this.getCollection(Constants.DefaultPageNumber);
    }
  }

  pageChanged(pageNumber: number = 1): void {
    this.getCollection(pageNumber);
  }

  abstract getCollection(pageNumber: number): void;

  private getModalComponentByClassName(className: string): any {
    const modal = ModalComponentFactory.find(x => x.name === className);
    return modal.component;
  }
}
